import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex-container-col gap40 fw align-center"
}
const _hoisted_2 = { class: "flex-container-row success" }
const _hoisted_3 = {
  key: 1,
  class: "flex-container-col gap40 fw"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "flex-container-col gap20" }
const _hoisted_6 = { class: "flex-container-col" }
const _hoisted_7 = { class: "flex-container-col" }
const _hoisted_8 = { class: "flex-container-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_error = _resolveComponent("error")!
  const _component_k_input = _resolveComponent("k-input")!
  const _component_k_button = _resolveComponent("k-button")!
  const _component_login_content = _resolveComponent("login-content")!

  return (_openBlock(), _createBlock(_component_login_content, {
    title: _ctx.title,
    "in-progress": _ctx.state.resetInProgress,
    links: _ctx.links
  }, {
    default: _withCtx(() => [
      (_ctx.state.completed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.localize('PasswordResetSuccess')), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.anyErrors)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_error, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.localize('PasswordResetError')), 1)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.errors, (error, index) => {
                      return (_openBlock(), _createElementBlock("li", { key: index }, [
                        _createVNode(_component_error, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.localize(error)), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_k_input, {
                  id: "txtUsername",
                  label: _ctx.localize('Username'),
                  modelValue: _ctx.data.username,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.username) = $event)),
                  disabled: true
                }, null, 8, ["label", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_k_input, {
                  id: "txtNewPassword",
                  ref: "refNewPassword",
                  placeholder: _ctx.localize('EnterNewPassword'),
                  label: _ctx.localize('NewPassword'),
                  type: "password",
                  modelValue: _ctx.data.newPassword,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.newPassword) = $event)),
                  onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.onEnter('newPassword')), ["enter"]))
                }, null, 8, ["placeholder", "label", "modelValue"]),
                _withDirectives(_createVNode(_component_error, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.localize('RequiredField')), 1)
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, !_ctx.newPasswordHasContent && _ctx.state.resetAttempt]
                ]),
                _withDirectives(_createVNode(_component_error, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.localize('NotTheSame')), 1)
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.entriesDeviate && _ctx.state.resetAttempt]
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_k_input, {
                  id: "txtConfirmPassword",
                  ref: "refConfirmPassword",
                  placeholder: _ctx.localize('EnterConfirmNewPassword'),
                  label: _ctx.localize('ConfirmNewPassword'),
                  type: "password",
                  modelValue: _ctx.data.confirmPassword,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.data.confirmPassword) = $event)),
                  onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.onEnter('confirmPassword')), ["enter"]))
                }, null, 8, ["placeholder", "label", "modelValue"]),
                _withDirectives(_createVNode(_component_error, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.localize('RequiredField')), 1)
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, !_ctx.confirmPasswordHasContent && _ctx.state.resetAttempt]
                ]),
                _withDirectives(_createVNode(_component_error, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.localize('NotTheSame')), 1)
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.entriesDeviate && _ctx.state.resetAttempt]
                ])
              ]),
              _createVNode(_component_k_button, {
                onClick: _ctx.resetPassword,
                class: "fw mt-20"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.localize('ResetPassword')), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]))
    ]),
    _: 1
  }, 8, ["title", "in-progress", "links"]))
}